'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/_react@15.6.2@react/react.js
// module id = 91
// module chunks = 0